module.exports = __webpack_public_path__ + "img/njr.435c8685.png";